const DESKTOP_AUTH_WALLET_KEY = "dwinity_desktop_auth_wallet";
export function loadDesktopAuthWallet() {
    return localStorage.getItem(DESKTOP_AUTH_WALLET_KEY)?.toLowerCase() ?? null;
}
export function storeDesktopAuthWallet(address) {
    localStorage.setItem(DESKTOP_AUTH_WALLET_KEY, address.toLowerCase());
}
export function clearDesktopAuthWallet() {
    localStorage.removeItem(DESKTOP_AUTH_WALLET_KEY);
}
export function isDesktopRefreshBindingCurrent(address, sourceRefreshToken) {
    return (loadDesktopAuthWallet() === address.toLowerCase()
        && localStorage.getItem("refreshToken") === sourceRefreshToken);
}
